import { GlButton, GlEmptyState } from '@gitlab/ui';
import { __, s__ } from '~/locale';
export default {
    name: 'EmptyStateWithAnyIssues',
    components: {
        GlButton,
        GlEmptyState
    },
    inject: {
        newIssuePath: {
            default: false
        },
        showNewIssueLink: {
            default: false
        }
    },
    props: {
        hasSearch: {
            type: Boolean,
            required: false,
            default: false
        },
        isEpic: {
            type: Boolean,
            required: false,
            default: false
        },
        withTabs: {
            type: Boolean,
            required: false,
            default: true
        },
        isOpenTab: {
            type: Boolean,
            required: false,
            default: true
        }
    },
    computed: {
        closedTabTitle () {
            return this.isEpic ? __('There are no closed epics') : s__('Issues|No closed issues');
        },
        openTabTitle () {
            return this.isEpic ? __('There are no open epics') : s__('Issues|No open issues');
        },
        noIssueDescription () {
            return this.isEpic ? '' : s__('Issues|Use issues (also known as tickets or stories on other platforms) to collaborate on ideas, solve problems, and plan your project.');
        }
    }
};
